module.exports = __webpack_public_path__ + "static/img/ydh2-benefit-bg2.e1e3d040.png";